module.exports = __webpack_public_path__ + "static/media/2.a33bde23.jpg";